import TweenLite from 'gsap/TweenMax'
require('gsap/ScrollToPlugin')
require('element-closest/element-closest')

export default {
  data () {
    return {
      tabIndex: 0,
      slideIndex: 0
    }
  },
  computed: {
    offsetY () {
      return (this.$store.state.device !== 2) ? 60 : 0
    }
  },
  methods: {
    scrollToSection (target = null, callback = null) {
      let ancestor = this.$el.closest('section[id]')
      let fromtop = ancestor.getBoundingClientRect().top
      let atBottom = (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight
      let sectionAtTop = (fromtop - this.offsetY < -1 || fromtop - this.offsetY > 1)
      if (target === null) {
        target = '#' + ancestor.id
      }
      if (sectionAtTop && !atBottom) {
        TweenLite.to(window, 0.5, {
          scrollTo: {
            y: target,
            autoKill: false,
            offsetY: this.offsetY
          },
          onComplete () {
            if (callback) {
              callback()
            }
          }
        })
      } else {
        callback()
      }
    },
    setTabIndex (val) {
      this.tabIndex = val
    },
    setSlideIndex (val) {
      this.slideIndex = val
    }
    // supportsVideo () {
    //   return !!document.createElement('video').canPlayType
    // },
    // canPlayVideo () {
    //   if (this.supportsVideo()) {
    //     let elem = document.createElement('video')
    //     elem.play().then(() => {
    //       return 'woot'
    //     }).catch(() => {
    //       return 'test'
    //     })
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js